!function(name, module, context){
	//>>excludeStart("requireTmpl", pragmas.requireTmpl);
	if(window.define) define('common/searchTab',['libs/ct_view', 'vendor/mustache'], module)
	else
	//>>excludeEnd("requireTmpl");
		context[name] = module(CT.View, Mustache)
}('searchTab', function(View, Mustache){


	var searchTabView = View({
		$el : $('.recentTabs'),
		
		
		tabId : 0,


		template : null,




		events : {
			'click li' : 'onClick'
		},



		initialize : function(){
			CT.cache.tabsMap = {}
		},



		// for multi-city scenario, first depart date is "depart_date_1"
		pickDepartDate : function(data) {
			return (data.depart_date) ? data.depart_date : data.depart_date_1;
		},


		pickCities : function(data){
			if(data.trip_type === 'MultiCity') //TODO can be more complicated
				return (data.origin1.split(",")[0] +" - "+ data['destination' + data.num_legs].split(",")[0])
			else
				return data.origin.split(",")[0] +" - "+ data.destination.split(",")[0]
		},

		
		// Creates HTML for a new tab - returns the HTML
		getTabHTMLData : function(data){
			var isNotHotel = /air|bus|train/.test(CT.app) // caching condition
			var isOneway = isNotHotel? !data.return_date : false // caching oneway or roundtrip check
			mustacheData = {}
			
			var mustacheData = {
				chk_in : (data.chk_in)?moment(CT.utils.swapDayMonth((isNotHotel)? this.pickDepartDate(data) : data.chk_in)).format('D MMM'):"",
				has_ret_date : isNotHotel? (isOneway? false : true) : true
			}
			
			if(mustacheData.chk_in.indexOf('NaN') > -1) mustacheData.chk_in = ""
			
			if(isNotHotel){
				var cities = /*this.pickCities(data).split('-')*/ ['', ''] //TODO when tabs are enabled, fix this
				mustacheData.from = cities[0].trim()
				mustacheData.to = cities[1].trim()
			} else {
				mustacheData.city = data.city
			}
			
			if(mustacheData.has_ret_date){
				mustacheData.chk_out = (data.chk_out)?(moment(CT.utils.swapDayMonth((isNotHotel) ? this.pickDepartDate(data) : data.chk_out)).format('D MMM')):("");
				if(mustacheData.chk_out.indexOf('NaN') > -1) mustacheData.chk_out = ""
			}
			
			if(isNotHotel) mustacheData.dir = isOneway? "→" : "⇄"
			
			return mustacheData
		},





		// Appends a new tab
		createTab : function(tabId, mustacheData){
			var $liCurrent = this.$('.current').removeClass('current').end()
				.find('ul').append(CT.to_html('RecentTabsTpl', mustacheData)).end()
				.find('li.current').attr('id', 'RecentTab_' + tabId);
			if(tabId <= 1) this.$el.hide()
			//hide the tabs bar on top
			//else this.$el.show()
			return $liCurrent
		},






		// Updates tab with newly created mustache data
		updateTabHTML : function($tab, mustacheData){
			$tab.html(CT.to_html('RecentTabsTpl', mustacheData))
			return this
		},












		toggleTab : function($el){
			$el.siblings().removeClass('current').end().addClass('current')
		},














		createSubTabId : function(currentId){
			var tabIds = currentId.split('_')
			var newSuffix = Int(tabIds[1]) + 1
			return tabIds[0] + '_' + newSuffix
		},















		onClick : function(e){
			e.preventDefault();
			var $t = $(e.target), data, tabId;
			if(!$t.is('li')) $t = $t.closest('li');
			if($t.hasClass('current')) return this;  // if active tab is clicked, do nothing
			tabId = $t.attr('data-currid');
			this.toggleTab($t); // toggle the "current" state on the tabs
			data = this.getData(tabId); // get the data stored in the tabs
			CT.settings.currentTab = tabId; // Update the global tab flag with the clicked tab's
			CT.fire('results.old', [_.pick(data, CT.settings[CT.app].searchParamKeys), tabId]) // goes to searchResult.js - display the hidden result container
			//TODO add logic to render results if it's a recent search tab
		},





		getData : function(key){
			return CT.cache.tabsMap[key]
		},
		
		

		setData : function(key, val){
			CT.cache.tabsMap =  (CT.cache.tabsMap || {});
			return CT.cache.tabsMap[key] = val;
		},







		// handles cases when new tab is not created, i.e show existing tab
		replaceExistingTab : function(existingTab, paramsHash, toRefresh){
			var mustacheData = this.getTabHTMLData(paramsHash)
			var $tab = $(existingTab.node)
			var tabData = this.getData($tab.attr('data-currid'))
			this.toggleTab($tab)
			if(typeof toRefresh === 'undefined') CT.settings.currentTab = (tabData.hasOwnProperty('chk_in') && tabData.chk_in === "") ? existingTab.tabId : this.createSubTabId($(existingTab.node).attr('data-currid'))
			//L('Setting new data on existing tab ', $tab, ' as: ', paramsHash)
			this.setData(CT.settings.currentTab, paramsHash)
			$tab.attr('data-currid', CT.settings.currentTab)
			return this
		},








		/**
		 
		 * * Opens a new search tab when modify search submit is clicked. This will also fire a message to create a new search results container
 		 * @param {Object} data - object containing all the params in the reault url
		 */
		openNewTabWith : function(paramsHash){
			//debugger;
			var tabId = ++this.tabId  // updating tab id check
			var $liCurrent

			// preparing Mustache data ======
			var mustacheData = this.getTabHTMLData(paramsHash)
			$liCurrent = this.createTab(tabId, mustacheData)
			// preparing Mustache data ======

			// Adding tabId to data and updating global current tab flag
			CT.settings.currentTab = tabId + '_1'
			//L('Setting new tab as', CT.settings.currentTab, ' with data: ', paramsHash)

			// Add data to the tab
			this.setData(CT.settings.currentTab, paramsHash)
			$liCurrent.attr('data-currid', CT.settings.currentTab)
		},







		/**
		 * @param {{Object}} - the initial hash from the basic results url (because later stuff gets added to the url like filters)
		 * @param {{Array}} - the params needed to determine if the tab is unique. If not, create a new tab
		 * @return {{Object}} Containing properties = node, tabId
		 */
		getCurrentTab : function(/* Object */paramsHash, /* Array */ tabCheckParams){
			tabCheckParams = tabCheckParams || CT.settings[CT.app].searchParamKeys //TODO remove when hotels is done
			var existingTab = {};
			var that = this
			var searchParamsHash = _.pick(paramsHash, tabCheckParams)
			var tabsMap = CT.cache.tabsMap
			_.each(tabsMap, function(tabCache, tabId){
				var searchTabDataHash = _.pick(tabCache, tabCheckParams)
				
				if(tabCache.hasOwnProperty('chk_in') && (!tabCache.chk && !tabCache.chk_out)){ //this tab does not have chk_in and chk_out
					searchTabDataHash.chk_in = searchParamsHash.chk_in
					searchTabDataHash.chk_out = searchParamsHash.chk_out
				}
				
				/*_.find(tabCheckParams, function(k){
					if(tabData[k] !== data[k]) {
						isSameTab = false;
						return true;
					}
				})*/
				if(_.isEqual(searchParamsHash, searchTabDataHash)){ // all basic params are the same
					existingTab.tabId = tabId;
					existingTab.node = that.$('#RecentTab_' + tabId.split('_')[0])[0] // the LI tab node
					return false; // break from the jquery loop
				}
			})
			
			
			
			return existingTab
		},








		/**
		 * @desc Starting point of tab creation
		 * @param {{Object}} - the initial hash from the basic results url (because later stuff gets added to the url like filters)
		 * @param {{Array}} - the params needed to determine if the tab is unique. If not, create a new tab
		 */
		openTab : function(/* Object */ paramsHash, /*Array*/tabCheckParams, /* Boolean */toRefresh){ // paramsHash contains all the validated url parameters and the search form serialized data
			var existingTab = this.getCurrentTab(paramsHash, tabCheckParams);
			if($.isEmptyObject(existingTab)){
				//L('Opening new tab')
				this.openNewTabWith(paramsHash);
			} else {
				//L('Replacing new tab')
				this.replaceExistingTab(existingTab, paramsHash, toRefresh)
			}
			return this
		}

	});


	CT.subscribe('tab.init', function(paramsHash, tabCheckParams, toRefresh){
		searchTabView.openTab(paramsHash, tabCheckParams, toRefresh);
	})

	// Searchtab View is initialized here.
	return searchTabView

}, CT.cache.views)
;
